import React from "react";
import LevelField from "./LevelField";
// import { 
//   FormProvider, 
//   useForm,
// } from "react-hook-form";

const SignatureLevel = ({ disabledField }: { disabledField?: () => boolean }) => {
  return (
    <>
      <LevelField disabledField={disabledField} />
    </>
  );
};

export default SignatureLevel;
